import { render } from "./FilterGroup.vue?vue&type=template&id=4505a6d4"
import script from "./FilterGroup.vue?vue&type=script&lang=js"
export * from "./FilterGroup.vue?vue&type=script&lang=js"

import "./FilterGroup.vue?vue&type=style&index=0&id=4505a6d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__